import { PropTypes } from "prop-types";
import { Link } from "gatsby";

import useResponsiveWithHydrationFix from "@hooks/useResponsiveWithHydrationFix";

function SearchCard({ card }) {
  const backgroundImage = useResponsiveWithHydrationFix(
    card.image.mobileImage.file.url,
    card.image.desktopImage.file.url
  );
  const textColor = useResponsiveWithHydrationFix(
    card?.textColor?.mobile,
    card?.textColor?.desktop
  );
  const { link } = card.image;

  if (link && link?.title !== "empty") {
    return (
      <Link
        className="flex bg-no-repeat bg-cover h-[100px] desktop:h-[170px] rounded-[12px] mobile:rounded-[6px] mobile:mb-[10px]"
        style={{
          backgroundImage: card.image ? `url(${backgroundImage})` : "none",
        }}
        to={link?.link?.link}
      >
        <p
          className="ml-[25px] mb-[20px] mobile:ml-[15px] mobile:mb-[10px] mt-auto typo-body font-bold underline"
          style={{ color: textColor || "#000" }}
        >
          {card.title}
        </p>
      </Link>
    );
  }
  return (
    <div
      className="flex bg-no-repeat bg-cover h-[100px] desktop:h-[170px] rounded-[12px] mobile:rounded-[6px] mobile:mb-[10px]"
      style={{
        backgroundImage: card.image ? `url(${backgroundImage})` : "none",
      }}
    >
      <p
        className="ml-[25px] mb-[20px] mobile:ml-[15px] mobile:mb-[10px] mt-auto typo-body font-bold underline"
        style={{ color: textColor || "#000" }}
      >
        {card.title}
      </p>
    </div>
  );
}

SearchCard.propTypes = {
  card: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      link: PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.shape({
          link: PropTypes.string,
        }),
      }),
      mobileImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      desktopImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    textColor: PropTypes.shape({
      mobile: PropTypes.string,
      desktop: PropTypes.string,
    }),
  }).isRequired,
};
export default SearchCard;
